'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function Home() {
  const router = useRouter()

  useEffect(() => {
    // Redirecionar automaticamente para a página de login
    router.push('/login')
  }, [router])

  return (
    <div className="min-h-screen bg-brand-gradient flex items-center justify-center">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p>Redirecionando para o login...</p>
      </div>
    </div>
  )
}
